/* Littl 2027 — global behaviour: header, menu, search, cart count + cart bar.
   Vanilla JS, no dependencies. Loaded with defer. */
(() => {
  const L = window.littl || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const body = document.body;
  body.classList.add('l-body');

  /* ---------- Money ---------- */
  const money = (cents) => {
    const v = cents / 100;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: L.currency || 'INR',
        minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return '₹' + v.toFixed(0); }
  };

  /* ---------- Scroll lock (menu / search) ---------- */
  let locks = 0;
  const lock = () => { locks++; body.classList.add('l-lock'); };
  const unlock = () => { locks = Math.max(0, locks - 1); if (!locks) body.classList.remove('l-lock'); };

  /* ---------- Header: shadow + hide on scroll down ---------- */
  const header = $('[data-l-header]');
  if (header) {
    let lastY = window.scrollY, ticking = false;
    const hideOnScroll = header.dataset.sticky !== 'false';
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 4);
      if (hideOnScroll && !body.classList.contains('l-lock')) {
        if (y > lastY + 6 && y > 140) header.classList.add('is-hidden');
        else if (y < lastY - 6 || y < 140) header.classList.remove('is-hidden');
      }
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
  }

  /* ---------- Desktop dropdowns ---------- */
  $$('[data-l-nav-item]').forEach((item) => {
    const btn = $('[data-l-nav-toggle]', item);
    if (!btn) return;
    let t;
    const open = () => { clearTimeout(t); $$('[data-l-nav-item].is-open').forEach((o) => o !== item && close(o)); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = (el = item) => { el.classList.remove('is-open'); const b = $('[data-l-nav-toggle]', el); if (b) b.setAttribute('aria-expanded', 'false'); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', () => { t = setTimeout(() => close(), 140); });
    btn.addEventListener('click', () => (item.classList.contains('is-open') ? close() : open()));
    item.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); btn.focus(); } });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-l-nav-item]')) $$('[data-l-nav-item].is-open').forEach((o) => { o.classList.remove('is-open'); const b = $('[data-l-nav-toggle]', o); if (b) b.setAttribute('aria-expanded', 'false'); });
  });

  /* ---------- Full-screen menu ---------- */
  const menu = $('[data-l-menu]');
  if (menu) {
    const openers = $$('[data-l-menu-open]');
    const back = $('[data-l-menu-back]', menu);
    const logo = $('[data-l-menu-logo]', menu);
    const title = $('[data-l-menu-title]', menu);
    const root = $('[data-l-panel="root"]', menu);
    let current = null;

    const showPanel = (id, label) => {
      const next = $(`[data-l-panel="${id}"]`, menu);
      if (!next) return;
      root.dataset.state = 'left'; root.setAttribute('aria-hidden', 'true');
      next.dataset.state = 'center'; next.removeAttribute('aria-hidden'); next.scrollTop = 0;
      current = next;
      back.hidden = false; logo.hidden = true; title.textContent = label || '';
      back.focus({ preventScroll: true });
    };
    const home = () => {
      if (current) { current.dataset.state = 'right'; current.setAttribute('aria-hidden', 'true'); }
      root.dataset.state = 'center'; root.removeAttribute('aria-hidden');
      current = null; back.hidden = true; logo.hidden = false; title.textContent = '';
    };
    const open = () => {
      if (menu.classList.contains('is-open')) return;
      home(); menu.classList.add('is-open'); lock();
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => $('[data-l-menu-close]', menu).focus({ preventScroll: true }), 50);
    };
    const close = () => {
      if (!menu.classList.contains('is-open')) return;
      menu.classList.remove('is-open'); unlock();
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (openers[0]) openers[0].focus({ preventScroll: true });
    };
    openers.forEach((b) => b.addEventListener('click', open));
    $('[data-l-menu-close]', menu).addEventListener('click', close);
    back.addEventListener('click', home);
    $$('[data-l-panel-open]', menu).forEach((b) => b.addEventListener('click', () => showPanel(b.dataset.lPanelOpen, b.dataset.lPanelTitle)));
    menu.addEventListener('keydown', (e) => { if (e.key === 'Escape') { current ? home() : close(); } });
    L.closeMenu = close;
    window.matchMedia('(min-width: 990px)').addEventListener('change', (m) => { if (m.matches) close(); });
  }

  /* ---------- Search overlay + predictive results ---------- */
  const search = $('[data-l-search]');
  if (search) {
    const input = $('[data-l-search-input]', search);
    const results = $('[data-l-search-results]', search);
    const idle = $('[data-l-search-idle]', search);
    const recentWrap = $('[data-l-recent-wrap]', search);
    const recentBox = $('[data-l-recent]', search);
    const form = $('[data-l-search-form]', search);
    const KEY = 'littl:recent-searches';
    let timer, controller, lastQ = '';

    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const getRecent = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
    const saveRecent = (q) => {
      q = q.trim(); if (!q) return;
      try { localStorage.setItem(KEY, JSON.stringify([q, ...getRecent().filter((x) => x.toLowerCase() !== q.toLowerCase())].slice(0, 6))); } catch (e) {}
    };
    const renderRecent = () => {
      const r = getRecent();
      recentWrap.hidden = !r.length;
      recentBox.innerHTML = r.map((q) => `<button type="button" class="l-chip" data-l-search-term="${esc(q)}">${esc(q)}</button>`).join('');
    };
    const go = (q) => { saveRecent(q); window.location.href = `${L.searchUrl}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`; };

    const imgUrl = (src, w) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '');
    const render = (q, data) => {
      const r = (data && data.resources && data.resources.results) || {};
      const products = r.products || [];
      const cols = r.collections || [];
      if (!products.length && !cols.length) {
        const wa = document.querySelector('.l-menu__quick .is-wa');
        results.innerHTML = `<p class="l-search__empty">No ribbons found for “${esc(q)}”. Try a colour, a code like KDC-05, or an occasion.${wa ? ` Or <a href="${wa.href}" target="_blank" rel="noopener">ask us on WhatsApp</a>.` : ''}</p>`;
        return;
      }
      let html = '';
      if (cols.length) {
        html += `<p class="l-search__h">Collections</p><div class="l-chips">${cols.slice(0, 4).map((c) => `<a class="l-chip" href="${c.url}">${esc(c.title)}</a>`).join('')}</div>`;
      }
      if (products.length) {
        html += `<p class="l-search__h">Ribbons</p>` + products.map((p, i) => {
          const img = p.featured_image && p.featured_image.url ? imgUrl(p.featured_image.url, 160) : '';
          const price = p.price ? money(Math.round(parseFloat(p.price) * 100)) : '';
          return `<a class="l-result" href="${p.url}" style="animation-delay:${i * 30}ms">
            <span class="l-result__img">${img ? `<img src="${img}" alt="" loading="lazy" width="56" height="70">` : ''}</span>
            <span class="l-result__t"><span class="l-result__name">${esc(p.title)}</span>${p.type ? `<span class="l-result__meta">${esc(p.type)}</span>` : ''}</span>
            <span class="l-result__price">${price}</span></a>`;
        }).join('');
      }
      html += `<a class="l-btn l-btn--ghost l-btn--block l-search__all" href="${L.searchUrl}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last" data-l-search-all>See all results for “${esc(q)}”</a>`;
      results.innerHTML = html;
    };

    const suggest = async (q) => {
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const url = `${L.suggestUrl}.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,tag`;
        const res = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        render(q, await res.json());
      } catch (e) { if (e.name !== 'AbortError') results.innerHTML = ''; }
    };

    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q === lastQ) return;
      lastQ = q;
      idle.hidden = !!q;
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(() => suggest(q), 180);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); const q = input.value.trim(); if (q) go(q); });
    search.addEventListener('click', (e) => {
      const t = e.target.closest('[data-l-search-term]');
      if (t) { input.value = t.dataset.lSearchTerm; input.dispatchEvent(new Event('input')); input.focus(); }
      if (e.target.closest('.l-result, [data-l-search-all]')) saveRecent(input.value);
    });

    const openers = $$('[data-l-search-open]');
    const open = () => {
      if (L.closeMenu) L.closeMenu();
      renderRecent();
      search.classList.add('is-open'); lock();
      openers.forEach((b) => b.setAttribute('aria-expanded', 'true'));
      setTimeout(() => input.focus(), 60);
    };
    const close = () => {
      if (!search.classList.contains('is-open')) return;
      search.classList.remove('is-open'); unlock();
      openers.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };
    openers.forEach((b) => b.addEventListener('click', open));
    $('[data-l-search-close]', search).addEventListener('click', close);
    search.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === '/' && !/input|textarea|select/i.test(document.activeElement.tagName) && !document.activeElement.isContentEditable) { e.preventDefault(); open(); }
    });
  }

  /* ---------- Cart: header count + bottom cart bar ---------- */
  const bar = $('[data-l-cartbar]');
  const setCart = (cart) => {
    if (!cart) return;
    const n = cart.item_count;
    $$('[data-l-cart-count]').forEach((el) => {
      const prev = parseInt(el.dataset.count || '0', 10);
      el.textContent = n; el.dataset.count = n;
      if (n > prev) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    $$('[data-l-cart-link]').forEach((a) => a.setAttribute('aria-label', `Cart, ${n} items`));
    if (!bar) return;
    const threshold = parseInt(bar.dataset.threshold || '99900', 10);
    const left = threshold - cart.total_price;
    $('[data-l-cartbar-count]', bar).textContent = `${n} ${n === 1 ? 'roll' : 'rolls'}`;
    $('[data-l-cartbar-value]', bar).textContent = money(cart.total_price);
    $('[data-l-cartbar-msg]', bar).textContent = left > 0 ? `Add ${money(left)} more for free delivery` : 'You’ve unlocked free delivery ✦';
    $('[data-l-cartbar-fill]', bar).style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + '%';
    bar.classList.toggle('is-visible', n > 0);
    body.classList.toggle('l-has-cartbar', n > 0);
  };
  const refreshCart = async () => {
    try { const r = await fetch(L.cartJs || '/cart.js', { headers: { Accept: 'application/json' } }); setCart(await r.json()); } catch (e) {}
  };
  L.refreshCart = refreshCart;
  L.setCart = setCart;
  if (bar && bar.classList.contains('is-visible')) body.classList.add('l-has-cartbar');

  // Littl sections dispatch this after add/update; Dawn sections publish via pubsub.
  document.addEventListener('littl:cart-changed', (e) => (e.detail && e.detail.cart ? setCart(e.detail.cart) : refreshCart()));
  const hookDawn = () => {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => refreshCart());
  };
  if (document.readyState === 'complete') hookDawn(); else window.addEventListener('load', hookDawn);
  // Keep in sync when returning to a tab or via back/forward cache.
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshCart(); });
})();
